












import { defineComponent, ref, computed } from "@vue/composition-api";
import { Location } from "vue-router";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { ROLES } from "@/const";
import BasePage from "@/components/BasePage";
import SixDigitConfirmView from "@/components/SixDigitConfirmView";

export default defineComponent({
  name: "PageForgotPasswordConfirmCode",
  components: { SixDigitConfirmView, BasePage },
  props: {
    email: { type: String, default: "" },
    changePassword: { type: Boolean, default: false },
  },
  setup(props, { root }) {
    const { authUser } = useAuthUser();

    const loading = ref(false);
    const token = ref("");
    const role = ref("");

    const nextRoute = computed<Location>(() => {
      return {
        name: props.changePassword ? "changePasswordSet" : "loginForgotSet",
        params: { token: token.value },
        query: { role: role.value },
      };
    });

    const codeResend = () => {
      if (loading.value) return;
      try {
        loading.value = true;
        providers.PasswordResetProvider.start({ data: { email: props.email } });
      } finally {
        loading.value = false;
      }
    };

    const submit = async (code?: string) => {
      if (!code) {
        alert("Enter verification code");
        return;
      }
      try {
        loading.value = true;
        let data = await providers.PasswordResetProvider.verify({ data: { code: code, email: props.email } });
        token.value = data?.token ?? "";
        role.value = data?.role ?? authUser.value?.role ?? ROLES.MEMBER;
        if (token.value) root.$router.push(nextRoute.value);
      } finally {
        loading.value = false;
      }
    };

    const resetPassword = async () => {
      if (props.changePassword) {
        await providers.PasswordResetProvider.start({ data: { email: props.email } });
      }
    };

    resetPassword();

    return {
      loading,
      token,
      nextRoute,
      codeResend,
      submit,
    };
  },
});
